module.exports = __webpack_public_path__ + "static/media/IMG_8929.a1d0cc05.JPG";